import { FacebookLoginPageProps } from '@frontend/sorghum/interface';
import { useLocation } from 'react-router-dom';
import { environment } from '../../environments/environment';
import { authorizations } from '../facebook-authorization';

interface useRoutesReturn extends FacebookLoginPageProps {
  key: string;
  googleStorageEndpoint: string;
  tapPayAppID: number;
  threadsAppID: string;
  igAppID: string;
  platformEndpoint: string;
}

export const useRoutes: () => useRoutesReturn = () => {
  const {
    mode,
    facebookAppID,
    googleStorageEndpoint,
    tapPayAppID,
    threadsAppID,
    igAppID,
    platformEndpoint,
  } = environment;
  const authorizationString = authorizations.join(',');
  const { key } = useLocation();

  return {
    mode,
    facebookAppID,
    googleStorageEndpoint,
    permission: authorizationString,
    tapPayAppID,
    key,
    threadsAppID,
    igAppID,
    platformEndpoint,
  };
};
